// extracted by mini-css-extract-plugin
module.exports = {"root":"Forms_root__vXqPm"};